import { useLoggedInUserStore } from '~/stores/loggedInUser'

export default defineNuxtPlugin(() => {
  // Injected as `$userSettings` (the file name predates the injection name).
  function userSettings() {
    const loggedInUser = useLoggedInUserStore().getLoggedInUser
    return loggedInUser?.settings ?? {}
  }
  return { provide: { userSettings } }
})
